import {} from "@lumora/bridge";
import { ViewModel } from "../mvvm/ViewModel.js";
const MIN_DESCRIPTION = 10;
/**
 * FeatureRequestViewModel powers the hidden in-site feature-request page. It
 * validates locally, then asks the backend to file a GitHub issue.
 */
export class FeatureRequestViewModel extends ViewModel {
    client;
    constructor(client) {
        super({
            title: "",
            description: "",
            errors: [],
            submitting: false,
            submitted: false,
            issueUrl: null,
        });
        this.client = client;
    }
    setTitle(title) {
        this.setState({ title });
    }
    setDescription(description) {
        this.setState({ description });
    }
    validate() {
        const errors = [];
        if (this.state.title.trim() === "")
            errors.push("Title is required.");
        if (this.state.description.trim().length < MIN_DESCRIPTION) {
            errors.push(`Description must be at least ${MIN_DESCRIPTION} characters.`);
        }
        return errors;
    }
    async submit() {
        const errors = this.validate();
        if (errors.length > 0) {
            this.setState({ errors });
            return false;
        }
        const ok = await this.run(async () => {
            const { url } = await this.client.createFeatureRequest(this.state.title.trim(), this.state.description.trim());
            this.setState({ submitted: true, issueUrl: url });
            return true;
        }, "Could not submit the request. Please try again.", { flag: "submitting", listErrors: true });
        return ok === true;
    }
}
//# sourceMappingURL=FeatureRequestViewModel.js.map